import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/shared/integrations/supabase/client";

export interface EditableAsset {
  id: string;
  name: string;
  category: string | null;
  category_id: string | null;
  description: string | null;
}

/** Hook: fetches a flat list of a property's assets (name-ordered) for inline editing. */
export function useEditablePropertyAssets(propertyId: string | null) {
  return useQuery<EditableAsset[]>({
    queryKey: ["editable-assets", propertyId],
    queryFn: async (): Promise<EditableAsset[]> => {
      if (!propertyId) return [];

      const { data, error } = await supabase
        .from("property_assets")
        .select("id, name, category_id, asset_categories(name), description")
        .eq("property_id", propertyId)
        .order("name", { ascending: true });

      if (error) throw error;
      return (data ?? []).map((a: any) => ({
        id: a.id,
        name: a.name,
        category: a.asset_categories?.name ?? null,
        category_id: a.category_id,
        description: a.description,
      })) as EditableAsset[];
    },
    enabled: !!propertyId,
    staleTime: 5 * 60 * 1000,
  });
}
